export default __webpack_public_path__ + "static/media/XR50P_outline.84994168.png";